var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
import ContactPhoneRows from './CompanyDetails/ContactPhoneRows.vue';
let CompanyDrawerContactTabPhones = class CompanyDrawerContactTabPhones extends Vue {
    constructor() {
        super(...arguments);
        this.showPhonesModal = false;
        this.clickCopyItem = false;
    }
    changeIconCopyClick(currVal) {
        if (currVal)
            setTimeout(() => {
                this.clickCopyItem = false;
            }, 300);
    }
};
__decorate([
    Prop({ default: () => { } })
], CompanyDrawerContactTabPhones.prototype, "allPhones", void 0);
__decorate([
    Watch('clickCopyItem')
], CompanyDrawerContactTabPhones.prototype, "changeIconCopyClick", null);
CompanyDrawerContactTabPhones = __decorate([
    Component({
        name: 'CompanyDrawerContactTabPhones',
        components: {
            Modal,
            ContactPhoneRows,
        },
    })
], CompanyDrawerContactTabPhones);
export default CompanyDrawerContactTabPhones;
